// extracted by mini-css-extract-plugin
export default {"images":"animation_images__rgq98","animation":"animation_animation__XDqi6"};